import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=511fb9cb&scoped=true&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=511fb9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fb9cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})
